export const YEARLY_SUBSCRIPTIONS = {
    STARTER: {
        PRICE_ID: "pri_01kevwvtw7sfskcw9c5zgkp277",
        PRICE_NAME: "Starter",
        PRICE: 182,
        CURRENCY: "$"
    },
    STANDARD: {
        PRICE_ID: "pri_01kevwx1z7a50jyddas3nqaxgr",
        PRICE_NAME: "Standard",
        PRICE: 470,
        CURRENCY: "$"
    },
    PREMIUM: {
        PRICE_ID: "pri_01kevwygjsj4y2ygtxd8mtg2fv",
        PRICE_NAME: "Premium",
        PRICE: 950,
        CURRENCY: "$"
    },

}